/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import { personFragment } from '../../../apollo/fragments/personFragment.gql';
import { CreditAppSavedSectionInfo } from '../../../apollo/fragments/CreditAppSavedSectionInfo.gql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetPeopleInfoData_creditApplication_CreditApplication_beneficialOwners_CreditApplicationPerson_address_CreditApplicationAddress = { readonly __typename: 'CreditApplicationAddress', readonly city: string | null, readonly state: string | null, readonly street: string | null, readonly streetAdditional: string | null, readonly postalCode: string | null, readonly countryCode: string | null };

export type GetPeopleInfoData_creditApplication_CreditApplication_beneficialOwners_CreditApplicationPerson = { readonly __typename: 'CreditApplicationPerson', readonly id: string | null, readonly firstName: string | null, readonly lastName: string | null, readonly title: string | null, readonly dob: any | null, readonly email: string | null, readonly passportCountry: string | null, readonly passportNumberLastFour: string | null, readonly passportExpiration: any | null, readonly passportNumberLength: number | null, readonly phoneNumber: string | null, readonly ssnLastFour: string | null, readonly verifiedPhoneNumber: string | null, readonly address: GetPeopleInfoData_creditApplication_CreditApplication_beneficialOwners_CreditApplicationPerson_address_CreditApplicationAddress | null };

export type GetPeopleInfoData_creditApplication_CreditApplication_authorizedSigner_CreditApplicationPerson = { readonly __typename: 'CreditApplicationPerson', readonly id: string | null, readonly firstName: string | null, readonly lastName: string | null, readonly title: string | null, readonly dob: any | null, readonly email: string | null, readonly passportCountry: string | null, readonly passportNumberLastFour: string | null, readonly passportExpiration: any | null, readonly passportNumberLength: number | null, readonly phoneNumber: string | null, readonly ssnLastFour: string | null, readonly verifiedPhoneNumber: string | null, readonly address: GetPeopleInfoData_creditApplication_CreditApplication_beneficialOwners_CreditApplicationPerson_address_CreditApplicationAddress | null };

export type GetPeopleInfoData_creditApplication_CreditApplication_outsourcedAccountant_CreditApplicationPerson = { readonly __typename: 'CreditApplicationPerson', readonly id: string | null, readonly email: string | null, readonly firstName: string | null, readonly lastName: string | null };

export type GetPeopleInfoData_creditApplication_CreditApplication_savedSectionsInfo_SavedSectionsInfo = { readonly __typename: 'SavedSectionsInfo', readonly sectionName: _Types.SectionName, readonly completedAt: any | null, readonly completionStatus: _Types.CompletionStatus | null };

export type GetPeopleInfoData_creditApplication_CreditApplication = { readonly __typename: 'CreditApplication', readonly salesforceCreditId: string, readonly fetchedAt: any | null, readonly hasOutsourcedAccountant: boolean | null, readonly beneficialOwners: ReadonlyArray<GetPeopleInfoData_creditApplication_CreditApplication_beneficialOwners_CreditApplicationPerson | null> | null, readonly authorizedSigner: GetPeopleInfoData_creditApplication_CreditApplication_authorizedSigner_CreditApplicationPerson | null, readonly outsourcedAccountant: GetPeopleInfoData_creditApplication_CreditApplication_outsourcedAccountant_CreditApplicationPerson | null, readonly savedSectionsInfo: ReadonlyArray<GetPeopleInfoData_creditApplication_CreditApplication_savedSectionsInfo_SavedSectionsInfo | null> | null };

export type GetPeopleInfoData_Query = { readonly __typename: 'Query', readonly creditApplication: GetPeopleInfoData_creditApplication_CreditApplication | null };


export type GetPeopleInfoDataVariables = _Types.Exact<{
  creditApplicationId: _Types.Scalars['ID']['input'];
}>;


export type GetPeopleInfoData = GetPeopleInfoData_Query;


export const GetPeopleInfoDataDocument = gql`
    query GetPeopleInfoData($creditApplicationId: ID!) {
  creditApplication(creditApplicationId: $creditApplicationId) {
    salesforceCreditId
    fetchedAt
    beneficialOwners {
      ...personFragment
    }
    authorizedSigner {
      ...personFragment
    }
    hasOutsourcedAccountant
    outsourcedAccountant {
      id
      email
      firstName
      lastName
    }
    ...CreditAppSavedSectionInfo
  }
}
    ${personFragment}
${CreditAppSavedSectionInfo}`;

/**
 * __useGetPeopleInfoData__
 *
 * To run a query within a React component, call `useGetPeopleInfoData` and pass it any options that fit your needs.
 * When your component renders, `useGetPeopleInfoData` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPeopleInfoData({
 *   variables: {
 *      creditApplicationId: // value for 'creditApplicationId'
 *   },
 * });
 */
export function useGetPeopleInfoData(baseOptions: Apollo.QueryHookOptions<GetPeopleInfoData, GetPeopleInfoDataVariables> & ({ variables: GetPeopleInfoDataVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPeopleInfoData, GetPeopleInfoDataVariables>(GetPeopleInfoDataDocument, options);
      }
export function useGetPeopleInfoDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPeopleInfoData, GetPeopleInfoDataVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPeopleInfoData, GetPeopleInfoDataVariables>(GetPeopleInfoDataDocument, options);
        }
export function useGetPeopleInfoDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPeopleInfoData, GetPeopleInfoDataVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPeopleInfoData, GetPeopleInfoDataVariables>(GetPeopleInfoDataDocument, options);
        }
export type GetPeopleInfoDataHookResult = ReturnType<typeof useGetPeopleInfoData>;
export type GetPeopleInfoDataLazyQueryHookResult = ReturnType<typeof useGetPeopleInfoDataLazyQuery>;
export type GetPeopleInfoDataSuspenseQueryHookResult = ReturnType<typeof useGetPeopleInfoDataSuspenseQuery>;
export type GetPeopleInfoDataQueryResult = Apollo.QueryResult<GetPeopleInfoData, GetPeopleInfoDataVariables>;